import React, { useState } from 'react';
import './FAQs.css';

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Do I need to buy expensive software first?',
      answer: 'No. We help you choose tools that fit your budget and needs. Many solutions use free or low-cost platforms, and we only recommend what makes sense for your business size and goals.'
    },
    {
      question: 'How long does digital transformation take?',
      answer: 'It depends on where you start and what you need. Simple digitisation can begin in days. Full transformation happens in phases — typically 3–6 months for foundational changes, with ongoing improvements over time.'
    },
    {
      question: 'Will my team be able to use these new systems?',
      answer: 'Yes. We design solutions your team can actually use, with hands-on training and clear documentation. Adoption is built into the process, not added later.'
    },
    {
      question: 'What if I\'m just starting out or very small?',
      answer: 'Perfect. Growing businesses benefit because you can build the right foundation from day one. We tailor everything to your scale and growth stage.'
    },
    {
      question: 'Do you only work with tech companies?',
      answer: 'Not at all. We work with retail, services, manufacturing, healthcare and education — any growing business looking to work smarter through digital tools and better processes.'
    },
    {
      question: 'What\'s the difference between digitisation, digitalisation, and digital transformation?',
      answer: 'Digitisation = moving from paper to digital. Digitalisation = fixing workflows and connecting systems. Digital Transformation = modernising your entire business model, internally and customer-facing, with AI and automation.'
    },
    {
      question: 'How do I know this will work for my business?',
      answer: 'We start with a free Digital Audit to assess where you are and what\'s realistic. No pressure, no generic advice — just honest guidance on what will actually move the needle for you.'
    },
    {
      question: 'Can you help with marketing and branding too?',
      answer: 'Yes. Creative Strategy is a core part of what we offer — from defining your USP to creating campaigns that reach the right customers without big-agency budgets.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faqs section" id="faqs">
      <div className="container">
        <h2 className="section-title">Frequently Asked Questions</h2>
        
        <div className="faqs-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button 
                className="faq-question"
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>
                <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQs;
